import List from './CourseBatchList'
import Details from './CourseBatchDetails'
const exportObj = {
    List,
    Details,
}

export default exportObj